import React from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import TitleCard from "../TitleCard"
import { WalletIcon } from "../icons"
import * as styles from "../steps.module.scss"

export default function SecondStep() {
  return (
    <Container>
      <TitleCard
        img={WalletIcon}
        backgroundColor="#00AEFF"
        title={<>ДЕНЬГИ НА КАРТУ</>}
        desc="Деньги ТОЛЬКО для безналичного расходования!"
      />

      <div className={styles.text_container}>
        <table className={styles.table}>
          <caption>
            При успешном внесении платежей по графику и&nbsp;соблюдении правил Программы вы получите
            одобрение на кредит наличными.
          </caption>
          <thead>
            <th>Продукт</th>
            <th>Вариант 1**</th>
            <th>Вариант 2**</th>
            <th>Вариант 3**</th>
            <th>Вариант 4**</th>
          </thead>
          <tbody>
            <tr>
              <td>Срок кредитования</td>
              <td colSpan={3} className={clsx(styles.red, styles.center, styles.bold, styles.big)}>
                3 или 6 мес.
              </td>
            </tr>
            <tr>
              <td>Сумма кредита</td>
              <td className={clsx(styles.red, styles.bold, styles.big)}>50 000 ₽</td>
              <td className={clsx(styles.red, styles.bold, styles.big)}>40 000 ₽</td>
              <td className={clsx(styles.red, styles.bold, styles.big)}>30 000 ₽</td>
              <td className={clsx(styles.red, styles.bold, styles.big)}>20 000 ₽</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Container>
  )
}
